var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { SharedService } from '../../services/shared.service';
import { KeycloakService } from '../../services/keycloak.service';
var MenuComponent = (function () {
    function MenuComponent(_service, _sservice, router) {
        this._service = _service;
        this._sservice = _sservice;
        this.router = router;
        this.menuChange = new EventEmitter();
    }
    MenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._service.findMenus(KeycloakService.getLoggedUser()).subscribe(function (response) {
            var routerConfig = _this.router.config;
            _this.menus = response;
            if (_this.menus) {
                _this.menuDef = _this.menus[0];
                _this.menus.forEach(function (menu, index) {
                    if (menu.child && menu.child.length > 0) {
                        menu.child.forEach(function (item, index) {
                            routerConfig.forEach(function (route) {
                                if ((route.component) && (route.component.name == item.aplicacion)
                                    && (route.path.length > 0) && (!item.url)) {
                                    item.url = route.path;
                                    return;
                                }
                            });
                        });
                    }
                    else {
                        routerConfig.forEach(function (route) {
                            if (menu.aplicacion.toLowerCase().startsWith(route.path)) {
                                if ((route.path.length) > 0 && (!menu.url)) {
                                    menu.url = route.path;
                                    return;
                                }
                            }
                        });
                    }
                    ;
                });
            }
            _this.router.resetConfig(routerConfig);
        });
    };
    MenuComponent.prototype.clickMenu = function (menu) {
        //console.log("Menu: " + menu.aplicacion);
        var value;
        value = 0;
        if (menu.aplicacion) {
            if (menu.aplicacion.toLowerCase().startsWith("cedula")) {
                value = 2;
            }
            if (menu.aplicacion.toLowerCase().startsWith("despacho")) {
                value = 1;
            }
            if (menu.aplicacion.toLowerCase().startsWith("agenda")) {
                value = 4;
            }
            if (menu.aplicacion.toLowerCase().startsWith("usuario")) {
                value = 3;
            }
        }
        //if (KeycloakService.getLoggedUser().toUpperCase() != "ANONIMO") {          
        this.menuChange.emit(value);
        //}
    };
    MenuComponent.prototype.getClasses = function (menu) {
        var tmp = document.URL.toLowerCase();
        var classes = "list-group-item";
        if (tmp.substring(tmp.lastIndexOf('/') + 1) == menu.url) {
            classes = "active " + classes;
        }
        if (menu.child && menu.child.length > 0) {
            classes = "sub-menu " + classes;
        }
        return classes;
    };
    MenuComponent.prototype.getMenuIcon = function (icon) {
        return "fa fa-" + icon;
    };
    return MenuComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", Object)
], MenuComponent.prototype, "menuChange", void 0);
MenuComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'menu',
        templateUrl: 'menu.component.html'
    }),
    __metadata("design:paramtypes", [CommonService, SharedService, Router])
], MenuComponent);
export { MenuComponent };
//# sourceMappingURL=menu.component.js.map